import { Component, OnInit } from '@angular/core';
import { ApiConnectionService } from '../services/api-connection.service'

@Component({
  selector: 'app-log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['./log-in.component.scss']
})
export class LogInComponent implements OnInit {

  // Models
  email: string = '';
  password: any = '';

  constructor(
    private apiService: ApiConnectionService,
  ) { }

  ngOnInit() {
  }

  getRaceName(){
    let _ = this;
    let raceName: any = location.href.split('/');
    console.log(raceName[4])

    return raceName[4];
  }

  getMerchant(){
    let _ = this;
    let merchant: any = location.href.split('/');

    return merchant[3];
  }

  createLogin(){
    let _ = this;
    let loginConditions = {
    	"user":{
    		"email": _.email,
    		"password": _.password
    	},
    	"merchant": _.getMerchant()
    }
    _.apiService.createLogin(loginConditions).subscribe(data => {
      console.log(data);
      localStorage.setItem('tokenL', data['token']);
    })
  }
}
